module.exports = __webpack_public_path__ + "img/ic_folder.43ca1b2d.svg";